import { LayoutTree as LayoutTreeSchema } from "@hq/contracts";
import { normalize } from "./normalize";
import type { IdOptions, LayoutTree } from "./types";

export function serialize(tree: LayoutTree): string {
  return JSON.stringify(tree);
}

/**
 * Parses and validates a serialized tree. Returns undefined for invalid JSON, a shape that does
 * not match the schema, or a different schema version, so callers fall back to a default.
 */
export function deserialize(json: string, opts: IdOptions = {}): LayoutTree | undefined {
  let data: unknown;
  try {
    data = JSON.parse(json);
  } catch {
    return undefined;
  }
  const parsed = LayoutTreeSchema.safeParse(data);
  return parsed.success ? normalize(parsed.data, opts) : undefined;
}
